var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliveryVan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 331,
    height: 214,
    viewBox: "0 0 331 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M153.837 164.599L254.524 220.363C278.868 233.845 306.289 240.791 334.116 240.525C361.943 240.258 389.226 232.788 413.307 218.842L481.441 179.423V102.866L376.304 191.319L238.318 117.409L153.837 164.599Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M445.705 27.3505L431.921 16.0879V53.8175C442.704 63.0292 449.442 76.1029 450.687 90.2289C451.933 104.355 447.586 118.406 438.581 129.361C423.068 148.257 401.327 161.005 377.26 165.317C353.194 169.629 328.378 165.221 307.269 152.886L145.431 58.4211L59.767 109.103L238.022 211.662C274.127 232.433 316.625 239.158 357.38 230.55C398.135 221.941 434.281 198.604 458.898 165.007L462.658 159.883C477.326 139.817 483.743 114.893 480.59 90.2396C477.436 65.5864 464.952 43.0795 445.705 27.3505Z",
    fill: "url(#paint0_linear_10_4088)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M446.592 26.2524L432.343 14.6378L432.16 14.849V18.1152L444.832 28.4345C463.834 43.9429 476.157 66.1512 479.262 90.4785C482.367 114.806 476.015 139.397 461.517 159.179L457.758 164.303C433.379 197.661 397.532 220.836 357.103 229.375C316.674 237.914 274.516 231.214 238.726 210.564L62.5549 109.201L145.431 60.0964L306.565 154.167C327.937 166.756 353.113 171.274 377.53 166.901C401.948 162.529 423.99 149.556 439.665 130.333C448.935 118.988 453.366 104.451 451.998 89.8656C450.63 75.2802 443.575 61.8195 432.357 52.3956L432.16 52.6209V55.9715C442.163 65.0913 448.291 77.6967 449.284 91.1955C450.276 104.694 446.058 118.06 437.497 128.545C422.24 147.251 400.788 159.875 377.025 164.131C353.262 168.387 328.761 163.994 307.959 151.746L146.135 57.1963L145.431 56.788L56.9651 109.187L237.318 212.958C273.71 233.952 316.576 240.761 357.683 232.077C398.79 223.392 435.238 199.827 460.025 165.908L463.784 160.784C478.709 140.429 485.247 115.122 482.048 90.0867C478.848 65.0516 466.156 42.2007 446.592 26.2524Z",
    fill: "#BB8CFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.667 100.531L130.263 102.972L135.144 105.781L136.549 103.34L131.667 100.531Z",
    fill: "url(#paint1_radial_10_4088)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M343.962 201.597L343.863 198.781C347.482 198.654 351.143 198.373 354.761 197.936L355.085 200.752C351.396 201.174 347.651 201.414 343.962 201.597ZM332.796 201.597C329.093 201.428 325.362 201.118 321.687 200.653L322.039 197.838C325.629 198.288 329.29 198.612 332.923 198.767L332.796 201.597ZM366.11 199.006L365.547 196.191C369.109 195.487 372.685 194.614 376.177 193.614L376.952 196.317C373.375 197.359 369.743 198.246 366.11 198.978V199.006ZM310.676 198.823C307.043 198.063 303.411 197.148 299.863 196.106L300.651 193.403C304.129 194.431 307.691 195.318 311.253 196.064L310.676 198.823ZM387.54 192.868L386.554 190.235C389.948 188.954 393.341 187.532 396.622 186.012L397.818 188.56C394.496 190.151 391.018 191.559 387.54 192.84V192.868ZM289.288 192.53C285.839 191.207 282.389 189.715 279.038 188.138L280.249 185.59C283.529 187.152 286.909 188.616 290.302 189.912L289.288 192.53ZM407.717 183.408L406.309 180.958C409.477 179.156 412.589 177.213 415.588 175.172L417.179 177.495C414.208 179.55 410.955 181.535 407.717 183.379V183.408ZM269.182 182.901L259.607 177.382L261.015 174.947L270.59 180.451L269.182 182.901ZM250.033 171.849L240.458 166.345L241.866 163.909L251.441 169.414L250.033 171.849ZM426.148 170.793L424.374 168.611C427.19 166.331 430.006 163.923 432.611 161.417L434.54 163.459C431.85 166.035 429.02 168.513 426.148 170.822V170.793ZM230.884 160.868L221.309 155.35L222.717 152.914L232.292 158.419L230.884 160.868ZM442.368 155.505L440.27 153.618C442.692 150.929 445.043 148.085 447.24 145.171L449.479 146.889C447.198 149.859 444.804 152.745 442.368 155.505ZM211.777 149.873L202.202 144.369L203.61 141.919L213.185 147.438L211.777 149.873ZM192.628 138.864L183.053 133.345L184.461 130.91L194.036 136.414L192.628 138.864ZM455.815 137.935L453.534 136.4C455.512 133.467 457.267 130.389 458.786 127.193L461.278 128.376C459.68 131.684 457.839 134.869 455.773 137.907L455.815 137.935ZM173.436 127.813L163.862 122.308L165.27 119.858L174.844 125.391L173.436 127.813ZM464.784 118.071L462.207 117.296C463.195 113.976 463.938 110.588 464.432 107.16L467.107 107.54C466.597 111.103 465.82 114.623 464.784 118.071ZM154.287 116.803L144.713 111.313L146.121 108.877L155.695 114.382L154.287 116.803ZM465.122 96.8124C465.089 93.3515 464.802 89.8977 464.263 86.479L466.924 86.0566C467.484 89.6059 467.786 93.1912 467.825 96.7842L465.122 96.8124ZM461.855 76.3849C460.813 73.0854 459.518 69.8708 457.983 66.7695L460.405 65.5728C462 68.7972 463.346 72.1388 464.432 75.5684L461.855 76.3849ZM452.703 57.8157C450.939 55.3017 449.015 52.9035 446.944 50.6358L446.156 49.946L448 47.961L448.901 48.7493C451.092 51.1337 453.124 53.6591 454.984 56.3093L452.703 57.8157Z",
    fill: "url(#paint2_radial_10_4088)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M267.534 110.243L268.013 117.592C268.012 117.851 268.082 118.105 268.216 118.327C268.35 118.549 268.543 118.73 268.773 118.849C269.003 118.968 269.261 119.022 269.52 119.004C269.778 118.986 270.027 118.897 270.238 118.746L274.884 115.931C275.126 115.791 275.321 115.582 275.443 115.332C275.566 115.081 275.612 114.799 275.574 114.523L274.631 107.216C274.615 106.961 274.53 106.714 274.385 106.504C274.24 106.293 274.04 106.126 273.807 106.02C273.574 105.914 273.316 105.874 273.062 105.904C272.808 105.933 272.566 106.032 272.364 106.189L268.14 109.004C267.947 109.147 267.791 109.334 267.685 109.549C267.58 109.765 267.528 110.003 267.534 110.243Z",
    fill: "url(#paint3_radial_10_4088)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M268.802 118.62L268.337 111.313C268.313 111.058 268.36 110.801 268.472 110.57C268.583 110.339 268.756 110.144 268.971 110.004L273.195 107.188C273.399 107.047 273.636 106.962 273.883 106.942C274.131 106.923 274.379 106.969 274.603 107.075C274.566 106.834 274.468 106.607 274.317 106.415C274.167 106.224 273.969 106.074 273.743 105.982C273.518 105.89 273.272 105.858 273.03 105.889C272.788 105.92 272.559 106.014 272.364 106.16L268.14 108.976C267.931 109.122 267.764 109.319 267.653 109.548C267.542 109.777 267.491 110.031 267.506 110.285L267.985 117.634C267.996 117.895 268.08 118.148 268.226 118.364C268.373 118.581 268.577 118.752 268.816 118.859L268.802 118.62Z",
    fill: "url(#paint4_radial_10_4088)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M66.7086 108.075L202.202 186.322C210.959 191.317 220.871 193.932 230.952 193.907C241.033 193.883 250.932 191.219 259.664 186.181L284.022 172.103C284.587 171.778 285.056 171.311 285.382 170.747C285.708 170.183 285.88 169.544 285.88 168.893C285.88 168.242 285.708 167.602 285.382 167.039C285.056 166.475 284.587 166.008 284.022 165.683L122.354 71.359C121.785 71.0343 121.142 70.8635 120.488 70.8635C119.833 70.8635 119.19 71.0343 118.622 71.359L66.6663 101.627C66.0973 101.953 65.6251 102.425 65.2981 102.994C64.9711 103.562 64.8011 104.207 64.8054 104.863C64.8097 105.519 64.9882 106.162 65.3226 106.727C65.657 107.291 66.1353 107.756 66.7086 108.075Z",
    fill: "#3B3E4C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M196.106 167.555L215.226 156.448L195.219 152.816L196.106 167.555Z",
    fill: "#58595B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.026 106.583L107.147 95.475L87.1389 91.8428L88.026 106.583Z",
    fill: "#58595B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M118.524 115.311C118.524 118.873 117.285 121.393 115.285 122.618L108.907 126.32C106.823 127.489 108.147 124.842 104.993 123.012C98.6283 119.338 93.4609 110.44 93.4609 103.134C93.4609 99.5295 90.1239 99.5013 92.1655 98.2906L98.9522 94.5317C101.022 93.4196 103.866 93.6167 106.992 95.4327C113.37 99.1072 118.524 108.005 118.524 115.311Z",
    fill: "url(#paint5_linear_10_4088)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M108.529 126.462C113 123.849 112.954 115.451 108.425 107.705C103.896 99.9589 96.5999 95.798 92.1288 98.4114C87.6577 101.025 87.7046 109.423 92.2335 117.169C96.7624 124.915 104.058 129.076 108.529 126.462Z",
    fill: "url(#paint6_linear_10_4088)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M100.881 98.9382C97.8399 97.1784 95.0661 96.9391 92.9963 97.9668C94.1822 97.732 95.403 97.7356 96.5875 97.9773C97.772 98.219 98.8966 98.694 99.8956 99.3746C106.26 103.007 111.484 111.904 111.484 119.197C111.484 123.012 110.076 125.616 107.851 126.743C110.667 125.954 112.483 123.153 112.483 118.817C112.413 111.51 107.26 102.613 100.881 98.9382Z",
    fill: "url(#paint7_radial_10_4088)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M100.712 102.444C95.8123 99.628 91.8417 101.881 91.8417 107.512C92.0136 110.58 92.9064 113.565 94.4476 116.223C95.9888 118.882 98.135 121.14 100.712 122.815C105.626 125.631 109.597 123.378 109.597 117.747C109.424 114.677 108.53 111.691 106.986 109.032C105.442 106.373 103.293 104.116 100.712 102.444ZM104.106 113.706L106.922 113.467C107.33 113.467 107.865 113.974 107.992 114.579C108.157 115.371 108.242 116.178 108.245 116.986C108.254 117.698 108.168 118.408 107.992 119.098C107.865 119.549 107.33 119.478 106.922 118.972L104.106 115.55C103.871 115.281 103.741 114.936 103.739 114.579V114.241C103.725 113.889 103.866 113.678 104.106 113.664V113.706ZM105.866 110.891L103.05 111.116C102.896 111.107 102.747 111.062 102.614 110.984C102.482 110.905 102.37 110.796 102.289 110.665L102.05 110.37C101.807 110.092 101.668 109.739 101.656 109.37V105.682C101.656 105.133 102.106 104.992 102.571 105.4C103.922 106.616 105.068 108.042 105.964 109.624C106.358 110.229 106.274 110.834 105.851 110.877L105.866 110.891ZM99.7266 104.598V108.23C99.7266 108.554 99.5717 108.765 99.3323 108.765H99.0789C98.9268 108.757 98.7788 108.713 98.6467 108.637C98.5146 108.561 98.4022 108.456 98.3186 108.328L95.5025 104.921C95.0942 104.401 95.0097 103.711 95.3336 103.514C95.8507 103.24 96.4175 103.073 97.0003 103.022C97.5831 102.972 98.1702 103.038 98.7269 103.218C99.0091 103.323 99.2543 103.508 99.432 103.751C99.6098 103.993 99.7122 104.283 99.7266 104.584V104.598ZM94.5873 106.329L97.4033 109.75C97.6315 110.023 97.7606 110.366 97.7694 110.722V111.06C97.7694 111.369 97.6286 111.58 97.4033 111.595L94.5873 111.834C94.179 111.834 93.6439 111.313 93.5172 110.722C93.3471 109.93 93.2575 109.124 93.2497 108.314C93.2445 107.602 93.3345 106.891 93.5172 106.203C93.6299 105.752 94.1649 105.822 94.5873 106.329ZM95.587 114.382L98.403 114.157C98.5575 114.162 98.7083 114.205 98.8412 114.284C98.9742 114.363 99.085 114.474 99.1634 114.607L99.4168 114.903C99.6507 115.181 99.7889 115.526 99.8111 115.888V119.535C99.8111 120.084 99.3464 120.224 98.8818 119.816C97.5388 118.593 96.394 117.168 95.4884 115.593C95.0801 115.03 95.1646 114.424 95.5729 114.382H95.587ZM101.726 120.675V117.043C101.726 116.719 101.867 116.508 102.12 116.508H102.36C102.512 116.512 102.662 116.555 102.794 116.631C102.927 116.707 103.039 116.815 103.12 116.944L105.936 120.351C106.344 120.872 106.429 121.562 106.091 121.759C105.574 122.033 105.007 122.201 104.424 122.251C103.841 122.302 103.254 122.235 102.698 122.055C102.415 121.949 102.17 121.761 101.995 121.515C101.819 121.269 101.721 120.977 101.712 120.675H101.726Z",
    fill: "url(#paint8_linear_10_4088)"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.219 102.669C95.3195 99.8533 91.3489 102.106 91.3489 107.723C91.5186 110.794 92.4104 113.781 93.9517 116.442C95.493 119.104 97.6404 121.364 100.219 123.04C105.119 125.856 109.09 123.603 109.09 117.972C108.918 114.904 108.025 111.919 106.484 109.26C104.943 106.602 102.797 104.343 100.219 102.669ZM103.613 113.932L106.358 113.706C106.781 113.706 107.316 114.213 107.428 114.818C107.606 115.609 107.696 116.416 107.696 117.226C107.707 117.934 107.617 118.641 107.428 119.323C107.316 119.788 106.781 119.718 106.358 119.211L103.613 115.79C103.379 115.519 103.245 115.176 103.233 114.818C103.233 114.818 103.233 114.706 103.233 114.649C103.233 114.593 103.233 114.537 103.233 114.481C103.162 114.129 103.317 113.903 103.556 113.875L103.613 113.932ZM105.373 111.116L102.557 111.355C102.402 111.35 102.252 111.307 102.119 111.228C101.986 111.149 101.875 111.038 101.796 110.905L101.557 110.609C101.315 110.331 101.175 109.978 101.163 109.609V105.977C101.163 105.428 101.613 105.287 102.078 105.696C103.436 106.906 104.582 108.333 105.471 109.919C105.851 110.454 105.725 111.06 105.316 111.088L105.373 111.116ZM99.2197 104.823V108.497C99.2197 108.807 99.0789 109.018 98.8395 109.032H98.5298C98.378 109.03 98.229 108.991 98.0962 108.917C97.9635 108.843 97.8512 108.738 97.7695 108.61L94.9534 105.189C94.531 104.682 94.4465 103.978 94.7844 103.781C95.3003 103.504 95.8672 103.335 96.4507 103.284C97.0341 103.233 97.6218 103.302 98.1778 103.485C98.45 103.587 98.6874 103.764 98.8621 103.996C99.0368 104.228 99.1413 104.505 99.1634 104.795L99.2197 104.823ZM94.0804 106.583L96.8965 109.99C97.1327 110.265 97.267 110.613 97.2767 110.975V111.313C97.2767 111.637 97.1358 111.848 96.8965 111.862L94.0804 112.101C93.658 112.101 93.1371 111.58 93.0103 110.989C92.8402 110.198 92.7506 109.391 92.7428 108.582C92.7376 107.869 92.8276 107.159 93.0103 106.47C93.0807 105.977 93.6017 106.034 94.0241 106.555L94.0804 106.583ZM95.0801 114.635L97.8962 114.396C98.0492 114.407 98.1977 114.453 98.3297 114.531C98.4617 114.61 98.5736 114.718 98.6565 114.847L98.9099 115.156C99.1424 115.434 99.2761 115.78 99.2901 116.142V119.76C99.2901 120.309 98.8396 120.45 98.3749 120.041C97.0278 118.822 95.8825 117.396 94.9816 115.818C94.5873 115.241 94.5873 114.635 95.0238 114.607L95.0801 114.635ZM101.219 120.928V117.296C101.219 116.972 101.36 116.761 101.613 116.761H101.853C102.005 116.769 102.153 116.813 102.285 116.889C102.417 116.965 102.529 117.07 102.613 117.198L105.429 120.605C105.837 121.111 105.922 121.815 105.584 122.012C105.067 122.286 104.5 122.453 103.917 122.504C103.334 122.554 102.747 122.488 102.191 122.308C101.898 122.204 101.643 122.014 101.46 121.762C101.276 121.511 101.173 121.211 101.163 120.9L101.219 120.928Z",
    fill: "url(#paint9_linear_10_4088)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M227.885 177.987C227.885 181.563 226.66 184.083 224.646 185.308L218.268 188.997C216.184 190.165 217.522 187.589 214.354 185.702C207.989 182.028 202.822 173.13 202.822 165.824C202.822 162.206 199.485 162.178 201.541 160.981L208.313 157.222C210.397 156.096 213.227 156.307 216.353 158.109C222.717 161.783 227.885 170.681 227.885 177.987Z",
    fill: "url(#paint10_linear_10_4088)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M221.211 181.774C221.211 189.081 216.043 192.023 209.679 188.349C203.315 184.675 198.161 175.777 198.161 168.471C198.161 161.164 203.315 158.222 209.679 161.896C216.043 165.57 221.211 174.468 221.211 181.774Z",
    fill: "url(#paint11_linear_10_4088)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M210.242 161.629C207.187 159.869 204.413 159.629 202.357 160.657C203.541 160.422 204.759 160.425 205.942 160.667C207.124 160.909 208.246 161.384 209.242 162.065C215.607 165.739 220.774 174.637 220.774 181.943C220.774 185.745 219.366 188.363 217.127 189.489C219.943 188.701 221.76 185.899 221.76 181.563C221.76 174.2 216.606 165.303 210.242 161.629Z",
    fill: "url(#paint12_radial_10_4088)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M210.045 165.134C205.131 162.318 201.16 164.571 201.16 170.188C201.331 173.258 202.224 176.245 203.768 178.904C205.312 181.564 207.463 183.821 210.045 185.491C214.945 188.307 218.916 186.068 218.916 180.437C218.744 177.369 217.851 174.384 216.31 171.725C214.768 169.067 212.622 166.808 210.045 165.134ZM213.424 176.397L216.24 176.171C216.649 176.171 217.184 176.678 217.31 177.283C217.481 178.075 217.571 178.881 217.578 179.691C217.582 180.399 217.492 181.104 217.31 181.789C217.184 182.239 216.649 182.183 216.24 181.662L213.424 178.255C213.201 177.979 213.072 177.638 213.058 177.283V176.946C213.072 176.566 213.227 176.368 213.452 176.34L213.424 176.397ZM215.184 173.581L212.439 173.82C212.286 173.81 212.137 173.763 212.005 173.685C211.873 173.607 211.761 173.499 211.678 173.37L211.425 173.06C211.186 172.785 211.048 172.438 211.031 172.075V168.442C211.031 167.879 211.495 167.753 211.96 168.161C213.309 169.375 214.451 170.802 215.339 172.384C215.677 172.919 215.677 173.525 215.212 173.553L215.184 173.581ZM209.045 167.288V170.934C209.045 171.244 208.89 171.455 208.651 171.469H208.412C208.259 171.471 208.109 171.434 207.975 171.359C207.842 171.285 207.73 171.178 207.651 171.047L204.835 167.626C204.427 167.119 204.343 166.415 204.68 166.218C205.196 165.947 205.761 165.782 206.341 165.733C206.922 165.685 207.506 165.754 208.06 165.936C208.338 166.036 208.582 166.214 208.762 166.448C208.942 166.683 209.05 166.965 209.073 167.26L209.045 167.288ZM203.92 169.034L206.736 172.441C206.968 172.717 207.098 173.065 207.102 173.426V173.75C207.102 174.074 206.976 174.285 206.736 174.299L203.92 174.538C203.512 174.538 202.977 174.017 202.85 173.412C202.684 172.625 202.599 171.823 202.597 171.019C202.587 170.307 202.672 169.597 202.85 168.907C203.005 168.442 203.512 168.499 203.92 169.034ZM204.92 177.086L207.736 176.847C207.888 176.861 208.035 176.909 208.167 176.986C208.298 177.064 208.411 177.171 208.496 177.298C208.568 177.407 208.648 177.51 208.736 177.607C208.971 177.884 209.11 178.23 209.13 178.593V182.239C209.13 182.788 208.665 182.929 208.201 182.507C206.855 181.289 205.713 179.863 204.821 178.283C204.413 177.706 204.511 177.1 204.92 177.072V177.086ZM211.059 183.379V179.733C211.059 179.409 211.214 179.198 211.453 179.198H211.706C211.858 179.202 212.006 179.243 212.138 179.316C212.271 179.39 212.383 179.494 212.467 179.62L215.212 183.042C215.621 183.548 215.705 184.252 215.367 184.449C214.853 184.723 214.288 184.89 213.708 184.941C213.127 184.992 212.542 184.925 211.988 184.745C211.719 184.626 211.489 184.433 211.325 184.189C211.16 183.945 211.068 183.659 211.059 183.365V183.379Z",
    fill: "url(#paint13_linear_10_4088)"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M209.51 165.345C204.61 162.53 200.639 164.782 200.639 170.413C200.811 173.482 201.704 176.466 203.245 179.125C204.786 181.784 206.933 184.042 209.51 185.716C214.41 188.532 218.395 186.279 218.395 180.662C218.221 177.591 217.326 174.604 215.783 171.942C214.239 169.281 212.09 167.021 209.51 165.345ZM212.903 176.608L215.719 176.368C216.128 176.368 216.663 176.889 216.789 177.481C216.955 178.272 217.04 179.079 217.043 179.888C217.052 180.6 216.967 181.31 216.789 182C216.663 182.45 216.128 182.394 215.719 181.873L212.903 178.466C212.671 178.19 212.542 177.841 212.537 177.481V177.157C212.523 176.791 212.664 176.58 212.861 176.566L212.903 176.608ZM214.663 173.792L211.847 174.031C211.695 174.018 211.548 173.97 211.416 173.892C211.285 173.814 211.172 173.708 211.087 173.581C211.015 173.472 210.935 173.368 210.848 173.271C210.606 172.998 210.467 172.65 210.453 172.286V168.639C210.453 168.09 210.904 167.95 211.369 168.358C212.719 169.574 213.865 171 214.762 172.581C215.156 173.144 215.072 173.75 214.663 173.778V173.792ZM208.524 167.499V171.131C208.524 171.455 208.369 171.666 208.13 171.666H207.877C207.725 171.658 207.576 171.615 207.444 171.539C207.312 171.463 207.2 171.357 207.116 171.23L204.413 167.837C203.99 167.33 203.92 166.626 204.244 166.429C204.761 166.156 205.328 165.989 205.911 165.938C206.493 165.887 207.081 165.954 207.637 166.134C207.894 166.257 208.113 166.447 208.269 166.686C208.425 166.924 208.514 167.2 208.524 167.485V167.499ZM203.371 169.245L206.187 172.666C206.411 172.942 206.539 173.282 206.553 173.637V173.975C206.553 174.299 206.412 174.496 206.187 174.524L203.371 174.749C202.963 174.749 202.428 174.243 202.301 173.637C202.13 172.846 202.04 172.039 202.033 171.23C202.029 170.522 202.119 169.816 202.301 169.132C202.428 168.654 203.005 168.724 203.371 169.231V169.245ZM204.371 177.312L207.116 177.072C207.271 177.077 207.421 177.121 207.554 177.2C207.687 177.279 207.798 177.39 207.877 177.523L208.13 177.818C208.367 178.1 208.505 178.451 208.524 178.818V182.45C208.524 182.999 208.06 183.14 207.595 182.732C206.245 181.514 205.1 180.088 204.202 178.508C203.878 177.931 203.948 177.326 204.413 177.298L204.371 177.312ZM210.51 183.605V179.958C210.51 179.649 210.65 179.437 210.904 179.423H211.143C211.296 179.421 211.446 179.459 211.58 179.533C211.713 179.607 211.825 179.715 211.904 179.846L214.72 183.267C215.128 183.774 215.212 184.477 214.874 184.675C214.359 184.952 213.792 185.121 213.208 185.172C212.625 185.223 212.037 185.154 211.481 184.97C211.201 184.862 210.959 184.673 210.786 184.427C210.614 184.182 210.517 183.891 210.51 183.591V183.605Z",
    fill: "url(#paint14_linear_10_4088)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M284.501 141.046L240.064 72.3445C239.423 71.3513 238.554 70.5258 237.53 69.9371L119.059 1.7422C117.949 1.10665 116.695 0.765285 115.416 0.750501C114.137 0.735718 112.875 1.04801 111.751 1.65774L78.3529 19.9594C76.8204 20.7997 75.63 22.1493 74.9878 23.7746L64.7796 45.5114C64.4576 46.3328 64.2859 47.2055 64.2727 48.0877L63.4983 88.1543C63.4693 89.4973 63.8049 90.8231 64.4694 91.9907C65.1338 93.1582 66.1023 94.124 67.2718 94.7851L88.1809 106.639C87.987 105.533 87.8881 104.412 87.8852 103.288C87.8852 95.0245 93.7144 91.688 100.923 95.8551C108.133 100.022 113.962 110.088 113.962 118.38C113.965 119.301 113.885 120.22 113.722 121.125L196.106 167.584C196.106 167.02 196.021 166.457 196.021 165.908C196.021 157.644 201.864 154.322 209.074 158.475C216.283 162.628 222.112 172.708 222.112 181C222.112 181.451 222.112 181.887 222.112 182.324L226.998 185.139C228.063 185.751 229.264 186.09 230.493 186.124C231.721 186.159 232.939 185.888 234.038 185.336L281.657 161.812C282.918 161.206 283.983 160.258 284.73 159.075C285.477 157.892 285.876 156.523 285.881 155.124V145.27C285.862 143.754 285.381 142.28 284.501 141.046Z",
    fill: "url(#paint15_radial_10_4088)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M230.602 164.81L224.125 144.819L197.232 93.8841C196.212 91.7943 194.588 90.0584 192.572 88.9005L76.0719 21.8881C75.6196 22.455 75.2542 23.0861 74.9878 23.7605L64.7796 45.4973C64.4576 46.3188 64.2859 47.1914 64.2727 48.0736L63.4983 88.1402C63.4693 89.4833 63.8049 90.809 64.4694 91.9766C65.1338 93.1442 66.1023 94.1099 67.2718 94.7711L88.1809 106.625C87.987 105.519 87.8881 104.398 87.8852 103.274C87.8852 95.0104 93.7144 91.6739 100.923 95.841C108.133 100.008 113.962 110.074 113.962 118.366C113.965 119.287 113.885 120.205 113.722 121.111L196.106 167.57C196.106 167.006 196.021 166.443 196.021 165.894C196.021 157.63 201.864 154.308 209.074 158.461C216.283 162.614 222.112 172.694 222.112 180.986C222.112 181.437 222.112 181.873 222.112 182.309L226.998 185.125C228.51 185.979 230.273 186.278 231.982 185.97V170.287C231.956 168.379 231.483 166.503 230.602 164.81Z",
    fill: "#E6E7E8"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M232.095 164.571L225.533 144.65L198.781 93.7152C197.769 91.6276 196.149 89.8951 194.134 88.7456L77.5644 21.7192C77.1561 22.226 77.8038 22.5639 77.5644 23.127L192.909 89.4777C194.922 90.6306 196.541 92.3622 197.556 94.4473L224.435 145.396L230.94 165.303C231.799 167.031 232.248 168.934 232.249 170.864V185.519C232.968 185.519 232.714 185.801 233.418 185.674V170.132C233.413 168.201 232.96 166.297 232.095 164.571Z",
    fill: "url(#paint16_radial_10_4088)"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M215.1 113.115L226.448 109.004C233.862 106.318 240.841 102.556 247.16 97.8401L250.174 95.6158C250.483 95.3712 250.841 95.1944 251.223 95.0968C251.605 94.9993 252.004 94.9832 252.393 95.0496C252.782 95.1159 253.153 95.2633 253.481 95.4821C253.809 95.7009 254.088 95.9863 254.299 96.3197L269.928 119.873C270.146 120.183 270.298 120.535 270.376 120.906C270.454 121.277 270.456 121.66 270.383 122.033C270.309 122.405 270.161 122.758 269.947 123.071C269.734 123.385 269.459 123.652 269.14 123.857L261.156 129.206C254.986 133.347 248.327 136.71 241.331 139.216L228.842 143.693C228.165 143.93 227.424 143.908 226.762 143.633C226.099 143.358 225.562 142.848 225.252 142.201L213.467 117.043C213.287 116.682 213.186 116.286 213.173 115.883C213.159 115.48 213.232 115.079 213.387 114.706C213.542 114.334 213.775 113.999 214.07 113.724C214.366 113.45 214.717 113.242 215.1 113.115Z",
    fill: "#10054D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M216.705 113.72L227.533 109.793C234.588 107.232 241.229 103.651 247.245 99.1634L250.061 97.0376C250.363 96.8238 250.705 96.6716 251.066 96.5898C251.427 96.508 251.8 96.4982 252.165 96.561C252.53 96.6238 252.879 96.7579 253.192 96.9556C253.505 97.1533 253.776 97.4108 253.989 97.7134L268.886 120.154C269.087 120.453 269.227 120.789 269.298 121.142C269.368 121.496 269.368 121.86 269.297 122.213C269.227 122.566 269.087 122.902 268.886 123.201C268.685 123.5 268.426 123.756 268.126 123.955L260.537 129.052C254.652 132.989 248.306 136.19 241.641 138.582L229.729 142.806C229.088 143.039 228.383 143.024 227.752 142.763C227.121 142.503 226.611 142.016 226.322 141.398L215.058 117.465C214.909 117.112 214.834 116.733 214.837 116.35C214.84 115.967 214.921 115.589 215.075 115.238C215.229 114.888 215.453 114.572 215.733 114.311C216.014 114.05 216.344 113.849 216.705 113.72Z",
    fill: "url(#paint17_linear_10_4088)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M190.136 106.611L190.797 128.714C190.801 128.988 190.877 129.256 191.018 129.491C191.159 129.726 191.36 129.919 191.6 130.051L218.155 145.256V141.511L204.596 111.763L192.501 105.161C192.254 105.028 191.976 104.962 191.695 104.97C191.414 104.978 191.141 105.059 190.901 105.206C190.662 105.352 190.465 105.559 190.331 105.806C190.196 106.053 190.129 106.33 190.136 106.611Z",
    fill: "#10054D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M191.544 106.034L192.205 128.418L211.509 139.582L210.988 128.502L204.174 112.918L191.544 106.034Z",
    fill: "url(#paint18_linear_10_4088)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M220.859 173.032L230.574 178.241C232.324 179.076 234.228 179.542 236.166 179.607C238.105 179.672 240.036 179.337 241.838 178.621L249.23 175.665C260.748 171.047 271.407 163.881 281.446 157.363L286.12 153.618L287.613 153.717L287.388 163.571L285.98 165.05C272.839 175.478 257.897 183.409 241.894 188.448C240.088 189.016 238.186 189.214 236.301 189.03C234.417 188.846 232.588 188.284 230.926 187.378L221.563 181.873L220.859 173.032Z",
    fill: "url(#paint19_linear_10_4088)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M229.856 168.428C231.101 169.19 232.515 169.631 233.972 169.712C235.429 169.793 236.884 169.512 238.205 168.893C238.744 168.639 239.33 168.505 239.925 168.499C240.521 168.493 241.11 168.616 241.653 168.86C242.196 169.103 242.68 169.461 243.072 169.909C243.463 170.357 243.753 170.884 243.922 171.455L245.231 175.862L238.445 178.551C237.318 178.996 236.111 179.205 234.9 179.163C233.689 179.122 232.499 178.832 231.405 178.311L229.504 177.41L229.856 168.428Z",
    fill: "url(#paint20_linear_10_4088)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M229.856 168.428C231.101 169.19 232.515 169.631 233.972 169.712C235.429 169.793 236.884 169.512 238.205 168.893C238.744 168.639 239.33 168.505 239.925 168.499C240.521 168.493 241.11 168.616 241.653 168.86C242.196 169.103 242.68 169.461 243.072 169.909C243.463 170.357 243.753 170.884 243.922 171.455L245.231 175.862L237.389 175.496C229.757 173.905 229.856 168.428 229.856 168.428Z",
    fill: "url(#paint21_linear_10_4088)"
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M281.15 150.732L280.559 157.166C280.559 157.166 286.064 153.745 286.388 152.421C286.503 149.276 286.432 146.126 286.177 142.989L284.586 144.918C283.62 145.574 282.811 146.436 282.217 147.441C281.624 148.446 281.259 149.57 281.15 150.732Z",
    fill: "url(#paint22_linear_10_4088)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M281.15 150.732L280.559 157.166C281.987 154.808 283.275 152.368 284.417 149.859C284.74 148.55 286.177 142.989 286.177 142.989L284.586 144.918C283.62 145.574 282.811 146.436 282.217 147.441C281.624 148.446 281.259 149.57 281.15 150.732Z",
    fill: "url(#paint23_linear_10_4088)"
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M269.928 119.873L268.365 117.507C268.301 117.96 268.143 118.395 267.901 118.783C267.658 119.171 267.337 119.504 266.957 119.76L257.988 125.757C251.045 130.413 243.554 134.196 235.685 137.02L224.66 140.962L225.238 142.201C225.547 142.848 226.085 143.357 226.748 143.633C227.41 143.908 228.151 143.93 228.828 143.693L241.317 139.216C248.313 136.71 254.972 133.347 261.142 129.206L269.126 123.857C269.446 123.653 269.722 123.387 269.937 123.074C270.152 122.761 270.302 122.408 270.377 122.036C270.452 121.664 270.45 121.28 270.373 120.908C270.296 120.537 270.145 120.184 269.928 119.873Z",
    fill: "#10054D"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M265.972 115.663L254.06 97.7134C253.846 97.4108 253.575 97.1533 253.262 96.9556C252.949 96.7579 252.601 96.6238 252.236 96.561C251.871 96.4982 251.497 96.508 251.136 96.5898C250.775 96.6716 250.433 96.8238 250.131 97.0376L247.315 99.1634C241.3 103.651 234.658 107.232 227.603 109.793L216.775 113.72C216.114 113.963 215.573 114.451 215.263 115.083C214.954 115.715 214.9 116.443 215.114 117.113C222.668 119.038 230.438 119.984 238.234 119.929C247.652 120.05 257.025 118.608 265.972 115.663Z",
    fill: "url(#paint24_linear_10_4088)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.7,
    d: "M199.851 89.5199L234.404 69.8526L116.032 2.23492L81.4928 21.5784L199.851 89.5199Z",
    fill: "url(#paint25_linear_10_4088)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M214.987 143.031C216.832 144.157 205.525 149.169 201.09 150.07C196.655 150.971 200.4 152.098 200.273 151.366C199.64 147.916 208.764 139.23 214.987 143.031Z",
    fill: "url(#paint26_linear_10_4088)"
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M201.695 136.893L202.442 145.664C202.465 145.984 202.567 146.293 202.737 146.565C202.907 146.837 203.141 147.063 203.419 147.224C203.696 147.384 204.009 147.475 204.329 147.488C204.65 147.501 204.968 147.435 205.258 147.297L214.776 144.481C215.172 144.31 215.501 144.013 215.712 143.637C215.923 143.26 216.005 142.825 215.945 142.398L212.805 134.19C212.764 133.908 212.661 133.637 212.504 133.399C212.348 133.16 212.141 132.958 211.898 132.808C211.655 132.658 211.382 132.562 211.099 132.529C210.815 132.495 210.527 132.524 210.256 132.613L203.005 134.866C202.594 135.013 202.243 135.291 202.007 135.658C201.77 136.024 201.661 136.458 201.695 136.893Z",
    fill: "url(#paint27_radial_10_4088)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M204.286 146.72L203.54 137.963C203.508 137.513 203.63 137.066 203.886 136.695C204.142 136.324 204.516 136.052 204.948 135.922L212.087 133.613C212.246 133.563 212.412 133.535 212.579 133.528C212.37 133.114 212.019 132.788 211.591 132.61C211.162 132.432 210.683 132.413 210.242 132.557L203.005 134.866C202.576 134.995 202.203 135.266 201.947 135.634C201.692 136.002 201.568 136.446 201.597 136.893L202.343 145.664C202.383 146.172 202.62 146.644 203.005 146.978C203.39 147.313 203.89 147.483 204.399 147.452C204.324 147.215 204.286 146.968 204.286 146.72Z",
    fill: "url(#paint28_radial_10_4088)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M200.485 157.194L110.076 105.33C112.484 109.258 113.823 113.747 113.962 118.352C113.965 119.273 113.885 120.191 113.722 121.097L196.106 167.555C196.106 166.992 196.021 166.429 196.021 165.88C195.965 161.389 197.753 158.362 200.485 157.194Z",
    fill: "url(#paint29_linear_10_4088)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M87.8852 103.274C87.8852 99.0508 89.3777 96.2352 91.7995 94.8273L63.6391 78.6515L63.4561 88.1121C63.4271 89.4551 63.7627 90.7809 64.4271 91.9484C65.0916 93.116 66.06 94.0817 67.2296 94.7429L88.1387 106.597C87.9605 105.498 87.8758 104.387 87.8852 103.274Z",
    fill: "url(#paint30_linear_10_4088)"
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M221.098 174.031L230.813 179.226C232.563 180.062 234.467 180.527 236.406 180.592C238.344 180.658 240.275 180.322 242.077 179.606L249.469 176.65C260.985 172.031 271.822 165.874 281.685 158.348L287.627 153.548V162.459C287.628 163.133 287.477 163.799 287.184 164.406C286.892 165.013 286.465 165.546 285.937 165.965L285.149 166.598C271.223 175.777 258.326 183.422 242.063 189.503C240.256 190.07 238.353 190.265 236.469 190.079C234.584 189.893 232.756 189.328 231.095 188.419L221.717 182.929L221.098 174.031Z",
    fill: "url(#paint31_linear_10_4088)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M242.697 171.652L240.346 176.622C240.346 176.622 233.193 172.201 233.897 170.667C234.601 169.132 242.697 171.652 242.697 171.652Z",
    fill: "url(#paint32_linear_10_4088)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M239.613 175.186C239.613 176.439 240.5 176.946 241.585 176.312C242.162 175.939 242.644 175.435 242.989 174.84C243.334 174.246 243.533 173.578 243.57 172.891C243.57 171.638 242.683 171.145 241.585 171.765C241.012 172.142 240.535 172.647 240.193 173.241C239.851 173.835 239.652 174.501 239.613 175.186Z",
    fill: "url(#paint33_linear_10_4088)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M237.825 172.652L235.967 176.594C235.967 176.594 230.334 173.074 230.827 171.863C231.32 170.653 237.825 172.652 237.825 172.652Z",
    fill: "url(#paint34_linear_10_4088)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M235.389 175.453C235.389 176.453 236.093 176.861 236.966 176.34C237.425 176.048 237.808 175.65 238.082 175.18C238.356 174.709 238.515 174.181 238.543 173.637C238.543 172.638 237.839 172.229 236.966 172.736C236.508 173.033 236.126 173.434 235.852 173.906C235.578 174.378 235.419 174.908 235.389 175.453Z",
    fill: "url(#paint35_linear_10_4088)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M285.107 149.873L283.501 153.266C283.501 153.266 280.756 151.197 281.249 150.141C281.741 149.085 285.107 149.873 285.107 149.873Z",
    fill: "url(#paint36_linear_10_4088)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M282.98 152.281C282.98 153.139 283.572 153.491 284.318 153.055C284.721 152.808 285.058 152.468 285.303 152.064C285.548 151.66 285.693 151.203 285.726 150.732C285.726 149.873 285.121 149.521 284.318 149.958C283.929 150.213 283.605 150.556 283.372 150.96C283.14 151.363 283.006 151.816 282.98 152.281Z",
    fill: "url(#paint37_linear_10_4088)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M285.754 147.072L284.585 149.549C284.585 149.549 282.586 148.029 282.938 147.269C283.29 146.509 285.754 147.072 285.754 147.072Z",
    fill: "url(#paint38_linear_10_4088)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M284.205 148.831C284.205 149.465 284.642 149.704 285.191 149.395C285.477 149.208 285.716 148.956 285.887 148.66C286.058 148.364 286.157 148.032 286.177 147.691C286.177 147.072 285.726 146.818 285.191 147.128C284.905 147.315 284.666 147.566 284.495 147.862C284.324 148.158 284.225 148.49 284.205 148.831Z",
    fill: "url(#paint39_linear_10_4088)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M234.446 169.709C232.827 169.713 231.239 169.269 229.856 168.428L229.546 177.41L231.447 178.311C232.663 178.892 234 179.177 235.347 179.142L234.446 169.709Z",
    fill: "url(#paint40_radial_10_4088)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M246.161 167.302L247.118 169.836C247.298 170.319 247.577 170.76 247.937 171.129C248.297 171.498 248.731 171.787 249.21 171.978C249.689 172.169 250.202 172.257 250.718 172.238C251.233 172.218 251.738 172.09 252.201 171.863C255.735 170.118 261.184 167.33 265.732 164.627C270.801 161.629 274.969 158.897 277.095 157.475C277.567 157.165 277.96 156.749 278.243 156.26C278.527 155.771 278.693 155.224 278.728 154.66L278.996 149.986C279.011 149.792 278.971 149.599 278.881 149.427C278.791 149.255 278.654 149.113 278.486 149.015C278.318 148.918 278.126 148.871 277.932 148.878C277.739 148.885 277.551 148.947 277.391 149.057C274.42 151.028 268.168 155.124 262.832 158.151C256.89 161.516 249.287 164.895 246.71 166.021C246.476 166.129 246.291 166.32 246.189 166.556C246.088 166.793 246.078 167.058 246.161 167.302Z",
    fill: "#10054D"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M278.052 148.845C278.137 149.016 278.181 149.204 278.179 149.395L277.898 154.068C277.863 154.632 277.697 155.181 277.414 155.669C277.13 156.158 276.737 156.574 276.264 156.884C274.138 158.292 269.97 161.023 264.901 164.036C260.354 166.739 254.905 169.526 251.384 171.258C250.879 171.508 250.322 171.637 249.758 171.637C249.194 171.637 248.638 171.508 248.132 171.258C248.679 171.744 249.358 172.056 250.083 172.154C250.808 172.252 251.545 172.131 252.201 171.807C255.735 170.061 261.184 167.274 265.732 164.571C270.801 161.572 274.969 158.841 277.095 157.419C277.567 157.108 277.96 156.692 278.243 156.204C278.527 155.715 278.693 155.167 278.728 154.603L278.996 149.929C279.008 149.662 278.917 149.401 278.741 149.199C278.565 148.997 278.319 148.871 278.052 148.845Z",
    fill: "url(#paint41_radial_10_4088)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M272.688 125.391C272.688 125.391 281.727 138.625 281.066 141.497C280.404 144.369 266.309 153.196 258.819 156.617C251.328 160.038 237.699 166.246 234.46 164.036C231.222 161.826 228.504 145.861 228.504 145.861C237.41 143.42 246.114 140.295 254.538 136.513C267.549 130.614 272.688 125.391 272.688 125.391Z",
    fill: "url(#paint42_linear_10_4088)"
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M268.83 128.714L268.745 128.587C268.66 128.464 268.548 128.361 268.418 128.286C268.288 128.211 268.143 128.166 267.994 128.154C267.844 128.142 267.694 128.163 267.554 128.216C267.413 128.269 267.287 128.352 267.182 128.46L266.943 128.643L261.311 132.458C256.896 135.415 252.134 137.817 247.132 139.61L240.937 141.835C240.834 141.871 240.74 141.929 240.661 142.004C240.582 142.079 240.519 142.17 240.477 142.271C240.434 142.371 240.413 142.479 240.415 142.589C240.417 142.698 240.441 142.805 240.486 142.905C240.683 143.316 241.024 143.641 241.444 143.818C241.865 143.994 242.336 144.01 242.767 143.862L250.709 141.046C255.177 139.452 259.433 137.314 263.381 134.683L268.45 131.276C268.837 130.984 269.094 130.552 269.165 130.073C269.236 129.593 269.116 129.105 268.83 128.714Z",
    fill: "#10054D"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M64.3571 60.8989L216.114 146.509L220.746 158.039L64.2445 70.1483L64.3571 60.8989Z",
    fill: "url(#paint43_linear_10_4088)"
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7379 79.5103L68.0884 82.3259V95.8269C66.3994 95.074 64.9713 93.8379 63.984 92.2745C62.9967 90.7111 62.4945 88.8905 62.5408 87.0421L62.7379 79.5103Z",
    fill: "#114082"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M195.092 158.123L114.666 112.003L115.159 111.144L195.585 157.264L195.092 158.123Z",
    fill: "#D1D3D4"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M202.371 104.753L72.7631 30.2083L72.2703 31.0671L156.991 79.8059V134.781H157.976V80.369L187.08 97.108V152.295H188.066V97.6712L201.879 105.611L202.371 104.753Z",
    fill: "url(#paint44_radial_10_4088)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M196.993 139.469C196.993 141.131 195.824 141.792 194.374 140.962C193.615 140.468 192.983 139.803 192.528 139.021C192.073 138.238 191.809 137.36 191.755 136.457C191.755 134.795 192.937 134.12 194.374 134.964C195.135 135.455 195.77 136.119 196.225 136.902C196.68 137.685 196.943 138.565 196.993 139.469Z",
    fill: "url(#paint45_linear_10_4088)"
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M196.95 139.357C197.528 140.511 196.486 140.694 194.641 139.765C192.872 138.919 191.36 137.617 190.262 135.992C189.685 134.838 190.727 134.655 192.572 135.584C194.338 136.434 195.849 137.735 196.95 139.357Z",
    fill: "url(#paint46_radial_10_4088)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M184.095 132.515C184.095 134.176 182.927 134.838 181.476 134.007C180.72 133.513 180.09 132.847 179.637 132.065C179.185 131.282 178.923 130.404 178.871 129.502C178.871 127.841 180.04 127.179 181.476 128.01C182.238 128.5 182.872 129.164 183.328 129.947C183.783 130.73 184.046 131.61 184.095 132.515Z",
    fill: "url(#paint47_linear_10_4088)"
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M184.053 132.43C184.63 133.585 183.588 133.768 181.744 132.839C179.975 131.993 178.463 130.69 177.365 129.066C176.788 127.911 177.83 127.728 179.674 128.657C181.441 129.507 182.951 130.809 184.053 132.43Z",
    fill: "url(#paint48_radial_10_4088)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M183.053 125.11C182.665 125.108 182.283 125.012 181.941 124.828L163.355 114.847C162.529 114.402 161.839 113.741 161.358 112.936C160.877 112.13 160.623 111.209 160.624 110.271V91.4345C160.624 90.811 160.871 90.213 161.312 89.7721C161.753 89.3312 162.351 89.0835 162.975 89.0835C163.395 89.0838 163.808 89.1955 164.172 89.4073L182.842 100.29C183.626 100.749 184.276 101.405 184.728 102.192C185.18 102.98 185.418 103.872 185.419 104.781V122.744C185.422 123.06 185.36 123.373 185.236 123.664C185.112 123.955 184.93 124.217 184.701 124.434C184.258 124.861 183.669 125.103 183.053 125.11ZM162.975 90.0689C162.601 90.0689 162.243 90.2173 161.979 90.4813C161.715 90.7453 161.567 91.1034 161.567 91.4768V110.313C161.571 111.07 161.779 111.811 162.168 112.46C162.556 113.109 163.112 113.641 163.777 114.002L182.363 123.983C182.62 124.118 182.912 124.169 183.199 124.132C183.487 124.094 183.755 123.968 183.969 123.772C184.229 123.51 184.375 123.156 184.377 122.787V104.781C184.375 104.046 184.182 103.325 183.817 102.688C183.451 102.051 182.926 101.521 182.293 101.148L163.623 90.266C163.426 90.1486 163.204 90.081 162.975 90.0689Z",
    fill: "#D1D3D4"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M183.293 125.87C182.903 125.876 182.52 125.778 182.18 125.588L163.58 115.607C162.755 115.164 162.066 114.506 161.585 113.703C161.104 112.9 160.849 111.982 160.849 111.046V92.2088C160.852 91.584 161.103 90.986 161.547 90.5455C161.99 90.105 162.589 89.8578 163.214 89.8578C163.631 89.8535 164.041 89.9657 164.397 90.1816L183.081 101.064C183.862 101.526 184.508 102.183 184.957 102.97C185.407 103.758 185.643 104.648 185.644 105.555V123.519C185.647 123.835 185.585 124.148 185.461 124.438C185.338 124.729 185.155 124.991 184.926 125.208C184.487 125.631 183.902 125.868 183.293 125.87ZM163.214 90.8433C162.841 90.8433 162.483 90.9916 162.219 91.2556C161.955 91.5196 161.806 91.8777 161.806 92.2511V111.088C161.811 111.844 162.018 112.585 162.407 113.234C162.796 113.883 163.352 114.416 164.017 114.776L182.603 124.758C182.861 124.89 183.154 124.939 183.441 124.899C183.728 124.859 183.996 124.731 184.208 124.532C184.339 124.407 184.443 124.256 184.513 124.089C184.583 123.922 184.618 123.742 184.616 123.561V105.555C184.615 104.821 184.422 104.099 184.056 103.463C183.691 102.826 183.165 102.295 182.532 101.923L163.862 91.0263C163.66 90.9116 163.432 90.8487 163.2 90.8433H163.214Z",
    fill: "url(#paint49_radial_10_4088)"
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8864 55.0705C83.8864 57.3371 83.3232 58.7449 82.2108 59.294C81.0985 59.843 79.3948 59.5051 77.3391 58.2803L73.9598 56.4079V42.6113L77.6911 44.7793C79.5621 45.831 81.1289 47.3491 82.239 49.1858C83.32 50.9581 83.8902 52.9946 83.8864 55.0705ZM81.2534 53.6627C81.3438 52.3848 81.0721 51.1073 80.4694 49.9768C79.8667 48.8463 78.9574 47.9085 77.846 47.2712L76.438 46.4828V55.4365L77.5221 56.056C80.0096 57.4638 81.2534 56.6426 81.2534 53.5923V53.6627Z",
    fill: "#000F45"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2638 67.4875L86.3645 63.447V49.7208L93.2638 53.6908V56.0841L88.9553 53.5923V56.6191L93.0104 58.9561V61.3353L88.9553 59.0265V62.5742L93.306 65.0801L93.2638 67.4875Z",
    fill: "#000F45"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M95.756 68.9375V55.1972L98.3045 56.605V67.8676L103.162 70.6832V73.0906L95.756 68.9375Z",
    fill: "#000F45"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M105.232 74.3999V60.6314L107.78 62.0392V75.7796L105.232 74.3999Z",
    fill: "#000F45"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M117.623 67.8113L120.185 69.2895L116.116 80.6788L113.3 79.0739L109.245 62.9965L111.807 64.4043L114.06 73.879C114.187 74.4421 114.314 75.0757 114.44 75.7936C114.567 76.5116 114.666 77.0044 114.694 77.2719C114.835 76.3709 115.042 75.4816 115.313 74.6111L117.623 67.8113Z",
    fill: "#000F45"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M128.591 87.8728L121.692 83.9027V70.1624L128.591 74.1465V76.5257L124.226 74.0198V77.0325L128.281 79.3695V81.7487L124.226 79.4117V82.9594L128.591 85.4794V87.8728Z",
    fill: "#000F45"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M133.618 85.5076V90.7869L131.083 89.3791V75.6388L134.575 77.6519C136.007 78.386 137.258 79.4296 138.236 80.7069C139.013 81.8101 139.422 83.1305 139.405 84.4799C139.457 85.1375 139.25 85.7895 138.827 86.296C138.612 86.5049 138.351 86.6607 138.065 86.7511C137.779 86.8416 137.476 86.8641 137.18 86.8169C138.982 90.9559 140.156 93.6307 140.7 94.8415L137.884 93.2084L135.068 86.296L133.618 85.5076ZM133.618 83.1425L134.434 83.6211C134.949 84.0075 135.58 84.2062 136.223 84.1842C136.603 84.0998 136.786 83.7197 136.786 83.0721C136.791 82.4468 136.588 81.8375 136.208 81.3404C135.694 80.7639 135.079 80.2867 134.392 79.9326L133.618 79.4962V83.1425Z",
    fill: "#000F45"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M145.882 89.7874L148.374 85.5639L151.105 87.1407L147.135 93.2365V98.6426L144.614 97.2348V91.885L140.644 81.1011L143.46 82.692L145.882 89.7874Z",
    fill: "#000F45"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7205 59.9838V62.6305L78.733 65.601V62.898L73.7205 59.9838Z",
    fill: "#000F45"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3942 64.3199V66.9666L86.4067 69.9511V67.2481L81.3942 64.3199Z",
    fill: "#000F45"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0679 68.67V71.3027L94.0804 74.2872V71.5842L89.0679 68.67Z",
    fill: "#000F45"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7557 73.0061V75.6528L101.768 78.6234V75.9203L96.7557 73.0061Z",
    fill: "#000F45"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M104.429 77.3422V79.9889L109.442 82.9594V80.2705L104.429 77.3422Z",
    fill: "#000F45"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M112.103 81.6924V84.325L117.116 87.3096V84.6066L112.103 81.6924Z",
    fill: "#000F45"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M119.791 86.0285V88.6752L124.803 91.6457V88.9427L119.791 86.0285Z",
    fill: "#000F45"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M127.465 90.3646V93.0113L132.477 95.9818V93.2928L127.465 90.3646Z",
    fill: "#000F45"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M135.138 94.7148V97.3474L140.151 100.332V97.6289L135.138 94.7148Z",
    fill: "#000F45"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M142.812 99.0508V101.698L147.839 104.668V101.965L142.812 99.0508Z",
    fill: "#000F45"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M0.25 133.894L43.6593 158.531L97.868 128.263L57.9788 104.33L0.25 133.894Z",
    fill: "#575B69"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4864 108.286V132.36L33.254 118.901V94.6443L56.4864 108.286Z",
    fill: "#CFAD17"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4581 108.286V132.36L78.4936 119.619V95.3623L56.4581 108.286Z",
    fill: "url(#paint50_linear_10_4088)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4937 95.3624L56.4582 108.286L33.254 94.6444L55.3459 81.7769L78.4937 95.3624Z",
    fill: "url(#paint51_linear_10_4088)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6302 102.599V109.06L41.3783 106.048V99.4028L46.6302 102.599Z",
    fill: "url(#paint52_linear_10_4088)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6516 89.6747L46.602 102.599L41.3783 99.4028L63.4701 86.5494L68.6516 89.6747Z",
    fill: "#3F62E0"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0651 117.015L53.9096 122.716L52.7128 122.026V128.812L51.4174 128.066V121.28L50.2206 120.59L52.0651 117.015Z",
    fill: "url(#paint53_linear_10_4088)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7572 118.014L47.6017 114.438L49.4321 120.14L48.2494 119.45V126.236L46.954 125.49V118.704L45.7572 118.014Z",
    fill: "url(#paint54_linear_10_4088)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1303 123.35V144.552L2.67175 132.712V111.341L23.1303 123.35Z",
    fill: "url(#paint55_linear_10_4088)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1022 123.35V144.552L42.5188 133.345V111.975L23.1022 123.35Z",
    fill: "url(#paint56_linear_10_4088)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5187 111.975L23.1021 123.35L2.67175 111.341L22.1306 100.008L42.5187 111.975Z",
    fill: "url(#paint57_linear_10_4088)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4429 118.352V124.04L9.82458 121.393V115.536L14.4429 118.352Z",
    fill: "#032396"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8454 106.963L14.4147 118.352L9.82458 115.536L29.2834 104.203L33.8454 106.963Z",
    fill: "#3F62E0"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2301 131.051L20.8493 136.062L19.8074 135.457V141.44L18.6669 140.779V134.795L17.6108 134.19L19.2301 131.051Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6825 131.923L15.3017 128.77L16.9209 133.796L15.8649 133.191V139.174L14.7244 138.512V132.529L13.6825 131.923Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4606 131.262V152.464L68.9191 140.61V119.239L48.4606 131.262Z",
    fill: "url(#paint58_linear_10_4088)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4887 131.262V152.464L29.0721 141.243V119.873L48.4887 131.262Z",
    fill: "url(#paint59_linear_10_4088)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0721 119.873L48.4887 131.262L68.9191 119.239L49.4603 107.92L29.0721 119.873Z",
    fill: "url(#paint60_linear_10_4088)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M57.134 126.25V131.938L61.7523 129.291V123.434L57.134 126.25Z",
    fill: "#032396"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7456 114.861L57.1622 126.25L61.7523 123.434L42.2935 112.115L37.7456 114.861Z",
    fill: "#3F62E0"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3468 138.949L50.7275 143.974L51.7836 143.369V149.352L52.9241 148.691V142.707L53.966 142.102L52.3468 138.949Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9084 139.821L56.2891 136.682L54.6699 141.694L55.7119 141.088V147.072L56.8524 146.41V140.427L57.9084 139.821Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8157 102.81V120.689L56.078 110.694V92.6734L38.8157 102.81Z",
    fill: "url(#paint61_linear_10_4088)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8438 102.81V120.689L22.4545 111.228V93.1943L38.8438 102.81Z",
    fill: "url(#paint62_linear_10_4088)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4545 93.1943L38.8438 102.81L56.078 92.6734L39.6605 83.1143L22.4545 93.1943Z",
    fill: "url(#paint63_linear_10_4088)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1373 98.5863V103.373L50.0375 101.148V96.207L46.1373 98.5863Z",
    fill: "#032396"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7761 88.9708L46.1514 98.5863L50.0375 96.207L33.62 86.662L29.7761 88.9708Z",
    fill: "#3F62E0"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0964 109.3L40.7306 113.523L41.6176 113.016V118.056L42.5751 117.507V112.467L43.4622 111.946L42.0964 109.3Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M46.785 110.032L45.4192 107.385L44.0535 111.609L44.9405 111.102V116.142L45.898 115.593V110.539L46.785 110.032Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M111.188 165.655V165.176H75.9874V166.049C75.933 166.932 76.1508 167.811 76.6116 168.566C77.0724 169.321 77.7539 169.917 78.5641 170.273L86.6602 174.947C90.5323 177.185 97.2908 176.903 101.768 174.327L107.555 170.976C110.16 169.498 111.484 167.499 111.188 165.655Z",
    fill: "url(#paint64_linear_10_4088)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6179 173.595L78.5218 168.935C74.6497 166.697 75.1426 162.783 79.606 160.207L85.3929 156.87C89.8704 154.294 96.6571 154.054 100.501 156.237L108.668 160.911C112.54 163.149 112.047 167.049 107.583 169.639L101.796 172.976C97.2485 175.552 90.49 175.833 86.6179 173.595Z",
    fill: "url(#paint65_linear_10_4088)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M107.513 169.301L101.726 172.638C97.2485 175.214 90.4619 175.453 86.618 173.257L78.5219 168.583C77.834 168.258 77.2374 167.768 76.7853 167.156C76.3332 166.545 76.0397 165.83 75.9311 165.078C75.919 165.931 76.1581 166.769 76.6188 167.487C77.0794 168.206 77.7413 168.773 78.5219 169.118L86.618 173.792C90.49 176.031 97.2485 175.749 101.726 173.173L107.513 169.822C110.09 168.344 111.329 166.415 111.188 164.613C111.075 166.218 109.836 167.95 107.513 169.301Z",
    fill: "url(#paint66_radial_10_4088)"
  }), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.188 167.696V167.218C110.952 168.187 110.5 169.09 109.866 169.86C109.232 170.63 108.433 171.248 107.527 171.666L101.74 175.003C97.2626 177.593 90.4759 177.818 86.632 175.636L78.5359 170.962C77.8571 170.642 77.2672 170.16 76.818 169.559C76.3688 168.957 76.0739 168.255 75.9593 167.513V168.09C75.9048 168.973 76.1226 169.852 76.5834 170.607C77.0442 171.363 77.7257 171.958 78.5359 172.314L86.632 176.988C90.5041 179.212 97.2626 178.945 101.74 176.354L107.527 173.018C110.16 171.525 111.484 169.526 111.188 167.696Z",
    fill: "url(#paint67_linear_10_4088)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1077 138.174H90.1802L82.6614 163.642V163.726C82.6614 167.26 87.5754 170.118 93.6439 170.118C99.7125 170.118 104.626 167.302 104.626 163.726V163.642L97.1077 138.174Z",
    fill: "url(#paint68_linear_10_4088)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1076 138.188C97.1076 139.3 95.5588 140.201 93.6439 140.201C91.729 140.201 90.1802 139.3 90.1802 138.188C90.1802 137.076 91.729 136.175 93.6439 136.175C95.5588 136.175 97.1076 137.076 97.1076 138.188Z",
    fill: "url(#paint69_linear_10_4088)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M104.627 163.642L103.134 158.588V158.771C103.134 161.812 98.91 164.289 93.644 164.289C88.378 164.289 84.1398 161.812 84.1398 158.771C84.1398 158.771 84.1398 158.644 84.1398 158.588L82.6473 163.642V163.726C82.6473 167.26 87.5613 170.118 93.6299 170.118C99.6985 170.118 104.612 167.302 104.612 163.726V163.642H104.627Z",
    fill: "url(#paint70_linear_10_4088)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M100.121 148.367V148.479C100.121 150.563 97.2204 152.252 93.644 152.252C90.0677 152.252 87.1671 150.563 87.1671 148.479C87.1603 148.438 87.1603 148.395 87.1671 148.353L85.6465 153.548C85.6515 153.58 85.6515 153.614 85.6465 153.646C85.6465 156.223 89.2229 158.306 93.63 158.306C98.0371 158.306 101.628 156.194 101.628 153.618C101.628 153.618 101.628 153.618 101.628 153.534L100.121 148.367Z",
    fill: "url(#paint71_linear_10_4088)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1077 138.174C97.1077 139.286 95.5589 140.187 93.644 140.187C91.7291 140.187 90.1803 139.286 90.1803 138.174L88.6737 143.285C88.6737 144.89 90.8984 146.185 93.644 146.185C96.3897 146.185 98.6143 144.89 98.6143 143.285L97.1077 138.174Z",
    fill: "url(#paint72_linear_10_4088)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M93.644 139.526C95.2148 139.526 96.4882 138.877 96.4882 138.076C96.4882 137.275 95.2148 136.626 93.644 136.626C92.0732 136.626 90.7998 137.275 90.7998 138.076C90.7998 138.877 92.0732 139.526 93.644 139.526Z",
    fill: "url(#paint73_linear_10_4088)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M93.644 139.526C95.2148 139.526 96.4882 138.877 96.4882 138.076C96.4882 137.275 95.2148 136.626 93.644 136.626C92.0732 136.626 90.7998 137.275 90.7998 138.076C90.7998 138.877 92.0732 139.526 93.644 139.526Z",
    fill: "url(#paint74_linear_10_4088)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M96.5304 137.273L94.2916 137.696L96.6853 163.177C96.6787 163.205 96.6787 163.234 96.6853 163.262C97.347 166.725 99.5013 169.231 101.444 168.893C103.387 168.555 104.458 165.401 103.782 161.938V161.84L96.5304 137.273Z",
    fill: "url(#paint75_radial_10_4088)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M91.2362 137.273L93.475 137.696L91.0813 163.177C91.0879 163.205 91.0879 163.234 91.0813 163.262C90.4196 166.725 88.2653 169.231 86.3222 168.893C84.3792 168.555 83.3091 165.401 83.9849 161.938V161.84L91.2362 137.273Z",
    fill: "url(#paint76_radial_10_4088)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10_4088",
    x1: 254.257,
    y1: 31.3064,
    x2: 315.489,
    y2: 289.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#7733DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#975CED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A56EF4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_10_4088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(450.181 304.19) scale(218.454 218.424)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_10_4088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(450.183 304.199) scale(218.454 218.424)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_10_4088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(270.28 110.919) scale(5.43495 5.43419)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#A5A6B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9EB3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_10_4088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(270.069 110.426) scale(5.22376 5.22302)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10_4088",
    x1: 115.877,
    y1: 122.435,
    x2: 95.647,
    y2: 95.3315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#2D2F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#43464A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#5D6066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1E1F21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46484D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10_4088",
    x1: 88.8138,
    y1: 112.441,
    x2: 111.863,
    y2: 112.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#1E1F21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2C2E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#515359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D6066"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_10_4088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(102.712 112.045) scale(12.4469 12.4451)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10_4088",
    x1: 91.8417,
    y1: 112.622,
    x2: 109.597,
    y2: 112.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10_4088",
    x1: 91.2926,
    y1: 112.847,
    x2: 109.034,
    y2: 112.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10_4088",
    x1: 225.223,
    y1: 185.125,
    x2: 204.994,
    y2: 158.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#2D2F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#43464A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#5D6066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1E1F21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46484D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10_4088",
    x1: 198.161,
    y1: 175.13,
    x2: 221.211,
    y2: 175.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#1E1F21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2C2E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#515359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D6066"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_10_4088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(212.058 174.735) scale(12.4469 12.4452)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_10_4088",
    x1: 201.189,
    y1: 175.313,
    x2: 218.944,
    y2: 175.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_10_4088",
    x1: 200.639,
    y1: 175.538,
    x2: 218.395,
    y2: 175.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_10_4088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(181.364 39.331) scale(169.892 169.868)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#A5A6B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9EB3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_10_4088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(155.414 103.739) scale(80.0319 80.0206)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_10_4088",
    x1: 214.903,
    y1: 119.746,
    x2: 269.421,
    y2: 119.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#251E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6AD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_10_4088",
    x1: 191.544,
    y1: 122.815,
    x2: 211.509,
    y2: 122.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A135D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363885"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_10_4088",
    x1: 272.111,
    y1: 184.548,
    x2: 263.495,
    y2: 176.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#1E1F21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2C2E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#515359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D6066"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_10_4088",
    x1: 229.546,
    y1: 173.792,
    x2: 245.231,
    y2: 173.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_10_4088",
    x1: 237.698,
    y1: 177.326,
    x2: 237.347,
    y2: 165.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_10_4088",
    x1: 280.559,
    y1: 150.056,
    x2: 286.5,
    y2: 150.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_10_4088",
    x1: 280.559,
    y1: 150.056,
    x2: 286.177,
    y2: 150.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_10_4088",
    x1: 214.917,
    y1: 108.216,
    x2: 265.972,
    y2: 108.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_10_4088",
    x1: 280.615,
    y1: 111.609,
    x2: 138.766,
    y2: 35.5696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#979899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#616263"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#373838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_10_4088",
    x1: 214.086,
    y1: 141.708,
    x2: 200.274,
    y2: 150.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_10_4088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(205.821 137.977) scale(7.30762 7.30661)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#A5A6B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9EB3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_10_4088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(204.258 131.923) scale(8.44812 8.44694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_10_4088",
    x1: 148.641,
    y1: 143.707,
    x2: 155.398,
    y2: 132.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_10_4088",
    x1: 72.1013,
    y1: 98.9523,
    x2: 78.1264,
    y2: 89.0405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_10_4088",
    x1: 221.098,
    y1: 171.877,
    x2: 287.669,
    y2: 171.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#2D2F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#43464A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#5D6066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1E1F21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46484D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_10_4088",
    x1: 233.855,
    y1: 173.398,
    x2: 242.697,
    y2: 173.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_10_4088",
    x1: 243.528,
    y1: 174.045,
    x2: 239.571,
    y2: 174.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E9EAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_10_4088",
    x1: 230.799,
    y1: 174.031,
    x2: 237.825,
    y2: 174.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_10_4088",
    x1: 238.487,
    y1: 174.538,
    x2: 235.347,
    y2: 174.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E9EAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_10_4088",
    x1: 281.192,
    y1: 151.436,
    x2: 285.107,
    y2: 151.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_10_4088",
    x1: 285.67,
    y1: 151.506,
    x2: 282.966,
    y2: 151.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E9EAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_10_4088",
    x1: 282.896,
    y1: 148.212,
    x2: 285.754,
    y2: 148.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_10_4088",
    x1: 286.162,
    y1: 148.268,
    x2: 284.191,
    y2: 148.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E9EAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_10_4088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(233.362 157.679) scale(3.01316 5.03126)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEECA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9951F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_10_4088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(272.364 169.343) scale(24.7108 24.7073)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_10_4088",
    x1: 312.169,
    y1: 152.098,
    x2: 224.21,
    y2: 141.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#979899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#616263"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#373838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_10_4088",
    x1: 138.968,
    y1: 115.368,
    x2: 145.852,
    y2: 103.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_10_4088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.321 91.2515) scale(63.0793 63.0704)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_10_4088",
    x1: 193.557,
    y1: 137.963,
    x2: 198.795,
    y2: 137.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_10_4088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(193.811 136.105) scale(5.06887 5.06817)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#A5A6B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9EB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_10_4088",
    x1: 180.674,
    y1: 131.008,
    x2: 185.897,
    y2: 131.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_10_4088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(180.927 129.164) scale(5.06886 5.06817)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#A5A6B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9EB3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_10_4088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(173.239 103.288) scale(20.0924 20.0896)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_10_4088",
    x1: 67.4759,
    y1: 95.3623,
    x2: 67.4759,
    y2: 132.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3C74B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_10_4088",
    x1: 55.8739,
    y1: 81.7769,
    x2: 55.8739,
    y2: 108.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECC947"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_10_4088",
    x1: 45.0955,
    y1: 104.555,
    x2: 30.7622,
    y2: 100.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#C97052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D47E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F2A48A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7AA90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_10_4088",
    x1: 13.5,
    y1: 110.191,
    x2: 6.08705,
    y2: 112.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#C97052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D47E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F2A48A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7AA90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_10_4088",
    x1: 9.0166,
    y1: 107.615,
    x2: 1.59326,
    y2: 110.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#C97052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D47E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F2A48A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7AA90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_10_4088",
    x1: 12.901,
    y1: 111.341,
    x2: 12.901,
    y2: 144.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC52F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_10_4088",
    x1: 32.8105,
    y1: 111.975,
    x2: 32.8105,
    y2: 144.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBCD41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3C74B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_10_4088",
    x1: 22.5952,
    y1: 100.008,
    x2: 22.5952,
    y2: 123.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECC947"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_10_4088",
    x1: 58.6898,
    y1: 119.239,
    x2: 58.6898,
    y2: 152.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBCD41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3C74B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_10_4088",
    x1: 38.7804,
    y1: 119.873,
    x2: 38.7804,
    y2: 152.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC52F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_10_4088",
    x1: 48.9956,
    y1: 107.92,
    x2: 48.9956,
    y2: 131.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECC947"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_10_4088",
    x1: 47.4468,
    y1: 92.6734,
    x2: 47.4468,
    y2: 120.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBCD41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3C74B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_10_4088",
    x1: 30.6491,
    y1: 93.1943,
    x2: 30.6491,
    y2: 120.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC52F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_10_4088",
    x1: 39.2662,
    y1: 83.1143,
    x2: 39.2662,
    y2: 102.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECC947"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_10_4088",
    x1: 111.385,
    y1: 170.836,
    x2: 75.4665,
    y2: 170.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A31CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C234B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#DC48C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF63CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#ED55C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E04BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DC48C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_10_4088",
    x1: 114.342,
    y1: 125.307,
    x2: 90.6219,
    y2: 170.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_10_4088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91.7432 170.104) scale(10.1096 10.1082)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_10_4088",
    x1: 111.385,
    y1: 172.877,
    x2: 75.4664,
    y2: 172.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A31CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C234B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#DC48C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF63CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#ED55C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E04BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DC48C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_10_4088",
    x1: 85.3366,
    y1: 152.238,
    x2: 103.767,
    y2: 156.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C8ABDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#DAC6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F7F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E8DBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D5BFE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#C7AFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#B397DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#A788DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A383DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#AE8DDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8A6DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_10_4088",
    x1: 85.759,
    y1: 134.246,
    x2: 96.1214,
    y2: 139.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_10_4088",
    x1: 83.6611,
    y1: 161.46,
    x2: 101.796,
    y2: 165.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C211A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C518A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CE2DAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#CF30B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF63CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#EB48BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C211A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A919AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AC18AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B715A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C211A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_10_4088",
    x1: 85.8295,
    y1: 151.14,
    x2: 103.965,
    y2: 154.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C211A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C518A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CE2DAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#CF30B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF63CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#EB48BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C211A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A919AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AC18AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B715A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C211A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_10_4088",
    x1: 88.026,
    y1: 140.751,
    x2: 106.161,
    y2: 144.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C211A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C518A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CE2DAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#CF30B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF63CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#EB48BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C211A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A919AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AC18AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#B715A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C211A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_10_4088",
    x1: 96.4178,
    y1: 138.076,
    x2: 90.124,
    y2: 138.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF63CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DC48C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_10_4088",
    x1: 93.644,
    y1: 136.949,
    x2: 93.644,
    y2: 147.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_10_4088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.609 143.919) rotate(-10.6182) scale(3.36477 10.3152)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#0D043D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#070222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#03010F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#010004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_10_4088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.288 195.406) rotate(-169.382) scale(3.36477 10.3152)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#230A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#040103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryVan);
export default __webpack_public_path__ + "static/media/deliveryVan.baba1a9866161c6640188ce563338a87.svg";
export { ForwardRef as ReactComponent };